import { Tooltip } from 'antd';
import { useAppDispatch } from 'lib/stores/hook';
import { HOTEL_DETAIL_TABS } from 'modules/Hotel/HotelDetailPage/constants';
import React, { useMemo } from 'react';
import { getPath } from 'routes/router-paths';
import useRouteMatch from 'utils/hooks/useRouteMatch';

export const renderSidebarLabel = (label: string) => {
  return (
    <Tooltip title={label} placement="right">
      {label}
    </Tooltip>
  );
};

export const useCheckActiveSidebarMenu = () => {
  const dispatch = useAppDispatch();

  const shouldActiveHotelListMenuItem = useRouteMatch([
    getPath('hotelListPage'),
    getPath('hotelDetailPage', ':hotelId', ':sectionId' as HOTEL_DETAIL_TABS),
  ]);

  const selectedMenuKeys = useMemo(() => {
    if (shouldActiveHotelListMenuItem) {
      return ['Ahihi'];
    }
    return null;
  }, [shouldActiveHotelListMenuItem]);
};
